import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { PromptOption } from 'src/app/pages/prompt-register/models/prompt-option.interface';
import { promptOptionActions } from '../../prompt/state/prompt-option.actions';
import { promptOptionSelectors } from '../../prompt/state/prompt-option.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';

@Directive({
   selector: '[ndtPromptSelect]',
   standalone: false,
})
export class PromptSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   //TODO: this should be the enum, but we don't have a way to convert the graphql enum string to a filter
   // We should probably just update our eager select to use graphql instead of a normal api endpoint
   @Input() promptTypesToInclude: number[];

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   protected destroyed$ = new Subject<void>();

   constructor(
      protected elementRef: ElementRef,
      protected formField: MatFormField,
      protected trigger: LcsSingleSelectDirective<PromptOption>,
      protected statusService: NgrxEagerSelectService<AppState, PromptOption>
   ) {}

   ngAfterViewInit(): void {
      const staticFilterOverride: string[] | undefined = ['isActive = true'];

      if (this.accountId) {
         staticFilterOverride.push(`AccountId=${this.accountId}`);
      }
      if (this.promptTypesToInclude.length > 0) {
         staticFilterOverride.push(`TypeId in (${this.promptTypesToInclude.join(',')})`);
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            promptOptionActions,
            promptOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('promptId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
